// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__EBqxO","row":"Node_row__2WZai","label":"Node_label__2bRVA","footer":"Node_footer__1kGXt"};